import { render, staticRenderFns } from "./FbMemberHeader.vue?vue&type=template&id=acecf10c"
import script from "./FbMemberHeader.vue?vue&type=script&lang=js"
export * from "./FbMemberHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports